import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastroservices from "../../components/breadcrumbastroservices";
import { useParams } from "react-router-dom";

const TagStyle = {
  display: "inline-block",
  padding: "4px 12px",
  background: "rgba(41, 100, 225, 0.1)",
  borderRadius: "40px",
  color: "#14a077",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "15px",
  marginRight: "8px"
};

AstrologersByCategory.propTypes = {};

function AstrologersByCategory(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

   const { clientId } = useParams();
    const [category, setCategory] = useState({ Named: "", Path1: "", Fdesc: "", Qdesc: ""});
  
    useEffect(() => {
      const fetchCategoryDetails = async () => {
        try {
          const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-subcategory-details/${clientId}`);
          setCategory(response.data); // Assuming response contains Named, Path1, Fdesc
        } catch (error) {
          console.error("Error fetching category details:", error);
        }
      };
  
      fetchCategoryDetails();
    }, [clientId]);

  const [data, setData] = useState([]);

 useEffect(() => {
    if (!category || !category.Named) return;

    const fetchAstrologersByService = async () => {
      try {
        const serviceName = encodeURIComponent(category.Named);
        const resp = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrologers-by-service/${serviceName}`
        );

        // Defensive: ensure array
        const rows = Array.isArray(resp.data) ? resp.data : [];

        // priority: permanent first, contractual second, others last
        const priority = (ctype) => {
          const t = String(ctype || "").trim().toLowerCase();
          if (t === "permanent") return 0;
          if (t === "contractual") return 1;
          return 2;
        };

        const sorted = rows.slice().sort((a, b) => {
          const pa = priority(a.Ctype);
          const pb = priority(b.Ctype);
          if (pa !== pb) return pa - pb;
          // fallback sort inside same group by name
          const nameA = String(a.Named || "").toLowerCase();
          const nameB = String(b.Named || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });

        console.log("astrologers-by-service (sorted sample):", sorted.slice(0, 5));
        setData(sorted);
      } catch (err) {
        console.error("Error fetching astrologers for service:", err);
        setData([]);
      }
    };

    fetchAstrologersByService();
  }, [category.Named]);

  const [reviewsMap, setReviewsMap] = useState({});

  const [categoryReviews, setCategoryReviews] = useState([]);
const [categoryReviewsLoading, setCategoryReviewsLoading] = useState(false);
const [expandedReviews, setExpandedReviews] = useState({});

  useEffect(() => {
  const fetchApprovedReviews = async () => {
    try {
      const res = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/reviews-approved"
      );

      const map = {};

      res.data.forEach((r) => {
        map[Number(r.AstrologerId)] = {
          avg: r.avgRating,
          count: r.totalReviews
        };
      });

      setReviewsMap(map);
    } catch (err) {
      console.error("Error fetching approved reviews:", err);
    }
  };

  fetchApprovedReviews();
}, []);

useEffect(() => {
  const fetchOtherCategoryReviews = async () => {
    setCategoryReviewsLoading(true);
    setExpandedReviews({});

    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/reviews-by-other-categories"
      );

      console.log("Other category reviews:", response.data);

      if (Array.isArray(response.data)) {
        setCategoryReviews(response.data);
      } else {
        setCategoryReviews([]);
      }
    } catch (error) {
      console.error(
        "Error fetching non-Tarot Card Reading reviews:",
        error
      );

      setCategoryReviews([]);
    } finally {
      setCategoryReviewsLoading(false);
    }
  };

  fetchOtherCategoryReviews();
}, []);

const renderStars = (rating) => {
  return (
    <div style={{ display: "flex", gap: "2px" }}>
      {[1,2,3,4,5].map((num) => (
        <span
          key={num}
          style={{
            color: num <= Math.round(rating) ? "#ffc107" : "#ddd",
            fontSize: "14px"
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

 
  return (
    <>
    <Helmet>
            <title>{category.Named} - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

          <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>
      
      <Header2 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbastroservices title="Showing Available Astrologers" />
        
     <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
           <div className="tf-container">
             <div className="row">
               <div className="col-md-12">
                <div className="row" style={{marginBottom:"20px"}}>
               
                    <div className="col-lg-12 col-12" style={{textAlign:"center"}}>
                    <h5 style={{marginTop:"10px", marginBottom:"0px"}}>{category.Named}</h5>
                    <p style={{fontStyle:"italic", maxWidth:"650px", padding:"auto", margin:"auto", marginBottom:"5px"}}><span style={{color:"#14A078", fontWeight:"bold"}}>{category.Qdesc}</span><br/>{category.Fdesc}</p>
        

</div>
                    </div>
                    </div>
     
               <div className="col-md-10" style={{margin:"auto"}}>
                 <div className="row">
      {data.map((item) => {
        const reviewData = reviewsMap[Number(item.Id)];
        const ctype = String(item.Ctype || "").trim().toLowerCase();
        const isPermanent = ctype === "permanent";
        const isContractual = ctype === "contractual";

        return (
          <div key={item.Id || item.Named} className="col-lg-4 col-md-4 col-12">
            <Link to={`/planner/${item.Id}/${encodeURIComponent(category.Named)}`} className="text-decoration-none">
              <div className="group-category-job padding wow fadeInUp" style={{ paddingBottom: "10px" }}>
                <div style={{
                  width: "unset",
                  padding: "18px",
                  marginLeft: "20px",
                  marginBottom: "20px",
                  borderRadius: "8px",
                  backgroundColor: "#f5f5f5",
                  boxShadow: "0px 2px 2px rgba(28, 36, 51, 0.1)"
                }}>
                  <div className="job-category-header" style={{ marginBottom: "0px" }}>
                   {/* Astrologer Image + Book Overlay */}
<div
  style={{
    position: "relative",
    width: "100%",
    overflow: "hidden",
    borderRadius: "10px",
    cursor: "pointer",
  }}
>
  <img
    src={item.Path1 || "default-image.jpg"}
    alt={item.Named}
    style={{
      width: "100%",
      height: "auto",
      display: "block",
      borderRadius: "10px",
      transition: "transform 0.3s ease",
    }}
  />

  {/* Book Astrologer Overlay */}
  <div
    style={{
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "12px 10px",
      background:
        "linear-gradient(to top, rgba(0,0,0,0.78), rgba(0,0,0,0))",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      minHeight: "90px",
    }}
  >
    <span
      style={{
        backgroundColor: "#14a077",
        color: "#fff",
        padding: "8px 18px",
        borderRadius: "25px",
        fontSize: "14px",
        fontWeight: "700",
        boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
      }}
    >
      Book Astrologer
      <span className="icon-keyboard_arrow_right"></span>
    </span>
  </div>
</div>

                    {/* Tags area */}
                    <div style={{ marginTop: 0 }}>
                      {isPermanent && <p style={TagStyle}>Trusted</p>}
                      {(isPermanent || isContractual) && <p style={TagStyle}>Verified</p>}
                    </div>

                    <h1 style={{
  marginTop: "10px",
  fontWeight: 600,
  fontSize: "18px",
  color: "#111",
  marginBottom: "3px"
}}>
  {item.Named}
</h1>

{/* ⭐ Ratings */}
{reviewData ? (
  <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "12px" }}>
    {renderStars(reviewData.avg)}
    <span style={{ fontSize: "12px", color: "#6b7280" }}>
      ({reviewData.avg}) • {reviewData.count}
    </span>
  </div>
) : (
  <span style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "8px" }}>
    New Astrologer
  </span>
)}

                    <p style={{ marginBottom: "4px", color: "#555", fontSize: "14px" }}>
                      <strong>Experience:</strong>{" "}
                      {item.Experience && String(item.Experience).trim() ? String(item.Experience).trim() : "Not specified"}+ years
                    </p>

                    <p style={{ marginBottom: "8px", color: "#555", fontSize: "14px" }}>
                      <strong>Language(s) Known:</strong>{" "}
                      {item.Languages && item.Languages.trim() ? item.Languages : "Not specified"}
                    </p>

                    <div>
                      <span className="btn-category-job" style={{ display: "inline-flex", alignItems: "center", color: "#14a077", fontWeight: "bold" }}>
                        View Plans & More
                        <span className="icon-keyboard_arrow_right" style={{ marginLeft: 6 }}></span>
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
               </div>
             </div>
           </div>
         </section>

         {/* ============================================================
    OTHER CATEGORY REVIEWS
============================================================ */}

<style>
  {`
    .category-reviews-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 18px;
    }

    .category-review-card {
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      text-align: left;
      transition: all 0.2s ease;
    }

    .category-review-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    }

    @media (max-width: 991px) {
      .category-reviews-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    @media (max-width: 767px) {
      .category-reviews-grid {
        grid-template-columns: 1fr;
      }
    }
  `}
</style>

{!categoryReviewsLoading && categoryReviews.length > 0 && (
  <section
    className="category-reviews-section"
    style={{
      padding: "20px 0 30px"
    }}
  >
    <div className="tf-container">

      <div
        style={{
          maxWidth: "1000px",
          margin: "auto"
        }}
      >

        {/* Heading */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "25px"
          }}
        >
          <h5
            style={{
              marginBottom: "7px",
              fontSize: "24px",
              fontWeight: 600
            }}
          >
            What Our Clients Say
          </h5>

          <p
            style={{
              margin: 0,
              color: "#777",
              fontSize: "14px"
            }}
          >
            Reviews from clients who experienced our{" "}
            <strong>{category.Named}</strong> services.
          </p>
        </div>

        {/* Reviews */}
        <div className="category-reviews-grid">

          {categoryReviews.map((review) => {

            const feedback = String(
              review.Feedback || "No feedback provided."
            ).trim();

            const maxLength = 180;
            const isLongReview = feedback.length > maxLength;
            const isExpanded = !!expandedReviews[review.Id];

            const displayedFeedback =
              isLongReview && !isExpanded
                ? `${feedback.substring(0, maxLength).trim()}...`
                : feedback;

            return (
              <div
                key={review.Id}
                className="category-review-card"
              >

                {/* Rating + Date */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "12px"
                  }}
                >

                  {renderStars(review.Rating)}

                  <span
                    style={{
                      fontSize: "11px",
                      color: "#999",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {review.CreatedAt
                      ? new Date(review.CreatedAt).toLocaleDateString("en-IN")
                      : ""}
                  </span>

                </div>

                {/* Feedback */}
                <p
                  style={{
                    marginBottom: "0",
                    color: "#444",
                    fontSize: "14px",
                    lineHeight: "1.7",
                    fontStyle: "italic"
                  }}
                >
                  "{displayedFeedback}"

                  {isLongReview && (
                    <>
                      {" "}
                      <button
                        type="button"
                        onClick={() => {
                          setExpandedReviews((prev) => ({
                            ...prev,
                            [review.Id]: !prev[review.Id]
                          }));
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          padding: 0,
                          margin: 0,
                          color: "#14a077",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer"
                        }}
                      >
                        {isExpanded ? "Read Less" : "Read More"}
                      </button>
                    </>
                  )}
                </p>

              </div>
            );
          })}

        </div>

      </div>

    </div>
  </section>
)}

{/* ============================================================
    END OTHER CATEGORY REVIEWS
============================================================ */}
        
      
      <div
                className="floating-buttons"
                style={{
                  position: "fixed",
                  bottom: "20px",
                  left: "20px",
                  zIndex: "1000",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {/* Call Button */}
                <a
                  href={`tel:+918960708425`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#007BFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaPhoneAlt />
                </a>
              
                {/* WhatsApp Button */}
                <a
                  href={`https://wa.me/918960708425`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#25D366",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaWhatsapp />
                </a>
              </div>
      <Footer />
      <Gotop />
    </>
  );
}

export default AstrologersByCategory;
